import { render, staticRenderFns } from "./JournalJson.vue?vue&type=template&id=4f954843&scoped=true&"
import script from "./JournalJson.vue?vue&type=script&lang=js&"
export * from "./JournalJson.vue?vue&type=script&lang=js&"
import style0 from "./JournalJson.vue?vue&type=style&index=0&id=4f954843&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f954843",
  null
  
)

export default component.exports